import React from "react";

const StepIndicator = ({ currentStep, totalSteps, currentPhase }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="mb-8">
      {/* Progress Bar */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium text-gray-600">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-primary-600">
          {Math.round(progress)}% Complete
        </span>
      </div>

      {/* Progress Bar Track */}
      <div className="w-full bg-gray-200 rounded-full h-3 shadow-inner">
        <div
          className="bg-gradient-to-r from-primary-500 to-primary-600 h-3 rounded-full transition-all duration-500 ease-out shadow-sm"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Current Phase */}
      {currentPhase && (
        <div className="mt-4 text-center">
          <h3 className="text-lg font-semibold text-gray-800">
            {currentPhase}
          </h3>
        </div>
      )}
    </div>
  );
};

export default StepIndicator;
